import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react'; 
import WorkflowsTable from './table/table.js';
import AppContext from "../../context/AppContext";
import {getSidebarItemFromPageStage} from "../home/home";

class Workflows extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<WorkflowsTable />}
                navigation={<SideBar activeHref="/workflows" items={getSidebarItemFromPageStage(this.context.pageStage)}/>}
                navigationOpen={true}
                toolsHide={true}
            />
        );
    }
}

export default Workflows;
